import axios from 'axios';
import { useEffect, useState } from 'react';
import { FcAlarmClock } from 'react-icons/fc';
import studentPlaceHodler from '../../../Image/exam_student_placeholder.png';
import logo from "../../../Image/logo.png";
import { BASE_URL } from '../../../insightConfig/insightConfig';

const ExamHeader = ({ module, Subject, exam_type, SubjectID, minutes, seconds, testOver, hours }) => {
    const [userData, setUserData] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/studentdashboard`)
                setUserData(response?.data?.data[0]);
            } catch (error) {
                alert.show(error?.response.data.message)
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);
    return (
        <div className="shadow-sm border">
            {/* Top Row */}
            <div className="d-flex justify-content-between align-items-center p-2 ">
                {/* Left Logo */}
                <div className="d-flex align-items-center gap-2">
                    <img src={logo} alt="NTA Logo" style={{ height: "50px" }} />
                    {/* <div className="d-flex flex-column">
                    <h5 className="m-0 fw-bold text-primary">NATIONAL TESTING AGENCY</h5>
                    <small className="text-success fw-semibold">Excellence in Assessment</small>
                  </div> */}
                </div>

                {/* Candidate Info */}
                <div className="d-flex align-items-center gap-3">
                    <img
                        src={userData?.ProfileImage || studentPlaceHodler}
                        alt="Candidate"
                        className="border"
                        style={{ width: "60px", height: "60px", objectFit: "cover" }}
                    />
                    <div className="d-flex flex-column small fw-bold">
                        <span>
                            Candidate Name:{" "}
                            <span className="fw-medium" style={{ color: "blue" }}>
                                {userData?.FirstName + " " + (userData?.LastName ?? "")}
                            </span>
                        </span>
                        <span>
                            Subject Name:{" "}
                            <span className="fw-medium" style={{ color: "blue" }}>
                                {SubjectID > 0 ? Subject : exam_type}
                            </span>
                        </span>
                        {!testOver && <span className="d-flex align-items-center">
                            {/* <FcAlarmClock className="me-1" /> */}
                            Remaining Time :{" "}
                            <b className="text-white ms-2 px-2 rounded" style={{ backgroundColor: "red", letterSpacing: "1px" }}>
                                {String(hours).padStart(2, "0")} : {String(minutes).padStart(2, "0")} : {String(seconds).padStart(2, "0")}
                            </b>
                        </span>
                        }
                    </div>
                </div>
            </div>

            {/* Second Row */}
            <div
                className="d-flex justify-content-between align-items-center px-4 py-2"
                style={{ backgroundColor: "#f54900" }}
            >
                {/* Subject Tabs */}
                <div className="d-flex gap-3 align-items-center fs-4">
                    <span className="fw-bold text-white">{module}</span>
                    <button className="btn btn-primary btn-sm fw-semibold px-3" style={{fontSize:"16px"}}>
                        {SubjectID > 0 ? Subject : exam_type}
                    </button>
                </div>

                {/* Right Side */}
                <div className="d-flex align-items-center gap-3">
                    {/* Download Question */}
                    {/* <button className="btn btn-primary btn-sm fw-semibold">
      ⬇ Download Question
    </button> */}

                    {/* Language Selector */}
                    <div className="d-flex align-items-center text-white fw-bold">
                        <label className="mb-0 me-2">Paper Language:</label>
                        <select
                            disabled
                            className="form-select form-select-sm w-auto border-0 shadow-sm"
                            style={{ fontSize: "0.85rem" }}
                        >
                            <option>English</option>
                            <option>Hindi</option>
                        </select>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default ExamHeader